module.exports = __webpack_public_path__ + "static/img/left-home-row-2.f834fa73.webp";